export const LRS_BASE_URL_PROD = 'https://lrs.zanichelli.it';
export const LRS_BASE_URL_TEST = 'https://lrs-test.zanichelli.it';